import React, {
    useEffect,
    useContext,
    useReducer,
    useState,
  } from "react"
  import { dataFetchReducer } from "../Utils/requestUtils"
  import { CircularProgress } from "@material-ui/core"
  import axios from "axios"
  import ErrorBoundary from "../Utils/ErrorBoundary"
  import { useHistory } from "react-router-dom"
  import AuthContext from "../../context/auth-context"
  
  function Dashboard(props) {
    let history = useHistory()
    let user_data = useContext(AuthContext).user_data
  
    if (
      !user_data.roles.includes("metrics_dashboard_viewer")
    ) {
      history.push("")
    }
    
    const [metabaseChartUrl, setMetabaseChartUrl] = useState("")
    const [pageState, dispatchPageState] = useReducer(dataFetchReducer, {
      fetchedData: null,
      isLoading: true,
      isError: false,
    })

    useEffect(() => {
		dispatchPageState({ type: "data_fetch_init" })
		const timer = setTimeout(() => {
			axios.get('/dash/metabase_proxy/metabase_chart_url').then(response => {
				dispatchPageState({
					type: "data_fetch_success",
					payload: response.data
				})
                setMetabaseChartUrl(response.data?.metabase_url)
			}).catch(error => {
				if ((error.response || {}).status === 403) dispatchPageState({ type: "data_fetch_failure_403" })
				else if ((error.response || {}).status === 404) dispatchPageState({ type: "data_fetch_failure_404" })
				else dispatchPageState({ type: "data_fetch_failure" })
			})
		}, 500);
		return () => {
			clearTimeout(timer)
		}
	}, [])
  
    const renderContent = () => {
      if (!user_data.roles.includes("metrics_dashboard_viewer")) {
        return (
          <div style={{ flexGrow: "1", display: "flex" }}>
            <p
              className={["blueText", "titleSize"].join(" ")}
              style={{ margin: "auto", textAlign: "center" }}
            >
              Você não possui permissões. Por favor contate seu administrador.
            </p>
          </div>
        )
      } else if (pageState.fetchedData && metabaseChartUrl.length > 0) {
        return (
          <React.Fragment>
            <div style={{ flexGrow: "1", display: "flex", flexDirection: 'column', height: '100vh' }}>
              <ErrorBoundary>
                <iframe
                    src={metabaseChartUrl}
                    title="Dashboard de Métricas"
                    width="100%"
                    height="100%"
                    style={{ border: 'none', minHeight: '90vh' }}
                    allowFullScreen
                />
              </ErrorBoundary>
            </div>
          </React.Fragment>
        )
      } else if (pageState.isError) {
        return (
          <React.Fragment>  
            <div style={{ flexGrow: "1", display: "flex" }}>
              <p
                className={["blueText", "titleSize"].join(" ")}
                style={{ margin: "auto", textAlign: "center" }}
              >
                {pageState.errorMessage}
              </p>
            </div>
          </React.Fragment>
        )
      } else if (pageState.isLoading) {
        return (
          <div style={{ height: "55vh", display: "flex" }}>
            <CircularProgress style={{ margin: "auto" }} />
          </div>
        )
      } else if (pageState.fetchedData && metabaseChartUrl.length === 0) {
        return (
            <div style={{ flexGrow: "1", display: "flex" }}>
              <p
                className={["blueText", "titleSize"].join(" ")}
                style={{ margin: "auto", textAlign: "center" }}
              >
                Você não dashboard associada. Por favor contate seu administrador.
              </p>
            </div>
          )
      }
      else return null
    }
    return (
      <div
        style={{
          width: "auto",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div style={{ display: "flex" }}>
          <div>
            <p className={["blueText", "titleSize"].join(" ")}>Métricas</p>
          </div>
        </div>
        {renderContent()}
      </div>
    )
  }
  
  export default Dashboard
  